import { render } from "./ExtendableChip.vue?vue&type=template&id=15b5a596&scoped=true"
import script from "./ExtendableChip.vue?vue&type=script&lang=js"
export * from "./ExtendableChip.vue?vue&type=script&lang=js"

import "./ExtendableChip.vue?vue&type=style&index=0&id=15b5a596&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b5a596"]])

export default __exports__